import { atom } from 'recoil';
import { View } from '../features/appointment/contexts/appointment-calendar';

const CalendarView = atom<View>({
  key: 'calendarView',
  default: 'month',
});

export default CalendarView;
